import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a3724e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-pages-profile" }
const _hoisted_2 = { class: "my-pages-profile__header" }
const _hoisted_3 = { class: "my-pages-profile__information-section" }
const _hoisted_4 = { class: "my-pages-profile__information-container" }
const _hoisted_5 = { class: "my-pages-profile__form-header" }
const _hoisted_6 = { class: "my-pages-profile__label" }
const _hoisted_7 = { class: "my-pages-profile__value" }
const _hoisted_8 = { class: "my-pages-profile__label" }
const _hoisted_9 = { class: "my-pages-profile__value" }
const _hoisted_10 = { class: "my-pages-profile__label" }
const _hoisted_11 = { class: "my-pages-profile__value" }
const _hoisted_12 = { class: "my-pages-profile__label" }
const _hoisted_13 = { class: "my-pages-profile__value" }
const _hoisted_14 = { class: "my-pages-profile__fieldset" }
const _hoisted_15 = { class: "my-pages-profile__form-group my-pages-profile__form-group--triple" }
const _hoisted_16 = { class: "my-pages-profile__label" }
const _hoisted_17 = { class: "my-pages-profile__value" }
const _hoisted_18 = { class: "my-pages-profile__form-group my-pages-profile__form-group--triple" }
const _hoisted_19 = { class: "my-pages-profile__label" }
const _hoisted_20 = { class: "my-pages-profile__value" }
const _hoisted_21 = { class: "my-pages-profile__form-group my-pages-profile__form-group--triple" }
const _hoisted_22 = { class: "my-pages-profile__label" }
const _hoisted_23 = { class: "my-pages-profile__value" }
const _hoisted_24 = { class: "my-pages-profile__label" }
const _hoisted_25 = { class: "my-pages-profile__value" }
const _hoisted_26 = { class: "my-pages-profile__label" }
const _hoisted_27 = { class: "my-pages-profile__value" }
const _hoisted_28 = { class: "my-pages-profile__form-information" }
const _hoisted_29 = { class: "my-pages-profile__form-information" }
const _hoisted_30 = { class: "umbraco-form-modal__header" }
const _hoisted_31 = { class: "umbraco-form-modal" }

import TressNavigationPills from "@/components/TressNavigationPills.vue";
import { onMounted, PropType, ref } from "vue";
import { ILiveLink } from "@/models/ILiveLink";
import { IMyPagesProfileForm } from "@/models/IMyPagesProfileForm";
import dictionary from "@/i18n/dictionary.json";
import { UmbracoFormsApi } from "@/services/Api";
import { IAntiForgeryToken } from "@/models/umbraco-forms/IAntiForgeryToken";
import { IUmbracoFormUserPreValues } from "@/models/umbraco-forms/IUmbracoFormUserPreValues";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressTheMyPagesProfile',
  props: {
  links: {
    type: Array as PropType<Array<ILiveLink>>,
    required: true,
  },
  formModel: {
    type: Object as PropType<IMyPagesProfileForm>,
    required: true,
  },
  requestChangeProfileFormId: {
    type: String,
    required: true,
  },
  antiForgeryToken: {
    type: Object as PropType<IAntiForgeryToken>,
    required: true,
  },
  preValues: {
    type: Object as PropType<IUmbracoFormUserPreValues>,
    required: false,
  },
},
  setup(__props) {

const props = __props;


const isModalOpen = ref<boolean>(false);
const onChangeMyDataClick = () => {
  isModalOpen.value = true;
};
const onModalClose = () => {
  isModalOpen.value = false;
};
const onModalOpen = () => {
  isModalOpen.value = true;
};
const requestChangeProfileFormDefinition = ref();
onMounted(async () => {
  requestChangeProfileFormDefinition.value = await UmbracoFormsApi.get(props.requestChangeProfileFormId);
});

return (_ctx: any,_cache: any) => {
  const _component_umbraco_form_field = _resolveComponent("umbraco-form-field")!
  const _component_umbraco_form_fieldset_column = _resolveComponent("umbraco-form-fieldset-column")!
  const _component_umbraco_form_fieldset = _resolveComponent("umbraco-form-fieldset")!
  const _component_umbraco_form_page = _resolveComponent("umbraco-form-page")!
  const _component_umbraco_form = _resolveComponent("umbraco-form")!
  const _component_tress_modal = _resolveComponent("tress-modal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(_unref(dictionary).profile.myInformation)), 1),
    _createVNode(TressNavigationPills, { links: __props.links }, null, 8, ["links"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t(_unref(dictionary).profile.customerData)), 1),
        _createElementVNode("dl", null, [
          _createElementVNode("dt", _hoisted_6, _toDisplayString(_ctx.$t(_unref(dictionary).form.customerNumber.label)), 1),
          _createElementVNode("dd", _hoisted_7, _toDisplayString(__props.formModel.customerNumber), 1)
        ]),
        _createElementVNode("dl", null, [
          _createElementVNode("dt", _hoisted_8, _toDisplayString(_ctx.$t(_unref(dictionary).form.companyName.label)), 1),
          _createElementVNode("dd", _hoisted_9, _toDisplayString(__props.formModel.companyName), 1)
        ]),
        _createElementVNode("dl", null, [
          _createElementVNode("dt", _hoisted_10, _toDisplayString(_ctx.$t(_unref(dictionary).form.fullName.label)), 1),
          _createElementVNode("dd", _hoisted_11, _toDisplayString(__props.formModel.fullName), 1)
        ]),
        _createElementVNode("dl", null, [
          _createElementVNode("dt", _hoisted_12, _toDisplayString(_ctx.$t(_unref(dictionary).form.address.label)), 1),
          _createElementVNode("dd", _hoisted_13, _toDisplayString(__props.formModel.streetAddress), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("dl", _hoisted_15, [
            _createElementVNode("dt", _hoisted_16, _toDisplayString(_ctx.$t(_unref(dictionary).form.zipCode.label)), 1),
            _createElementVNode("dd", _hoisted_17, _toDisplayString(__props.formModel.zipCode), 1)
          ]),
          _createElementVNode("dl", _hoisted_18, [
            _createElementVNode("dt", _hoisted_19, _toDisplayString(_ctx.$t(_unref(dictionary).form.city.label)), 1),
            _createElementVNode("dd", _hoisted_20, _toDisplayString(__props.formModel.city), 1)
          ]),
          _createElementVNode("dl", _hoisted_21, [
            _createElementVNode("dt", _hoisted_22, _toDisplayString(_ctx.$t(_unref(dictionary).form.country.label)), 1),
            _createElementVNode("dd", _hoisted_23, _toDisplayString(__props.formModel.country), 1)
          ])
        ]),
        _createElementVNode("dl", null, [
          _createElementVNode("dt", _hoisted_24, _toDisplayString(_ctx.$t(_unref(dictionary).form.phoneNumber.label)), 1),
          _createElementVNode("dd", _hoisted_25, _toDisplayString(__props.formModel.phoneNumber), 1)
        ]),
        _createElementVNode("dl", null, [
          _createElementVNode("dt", _hoisted_26, _toDisplayString(_ctx.$t(_unref(dictionary).form.email.label)), 1),
          _createElementVNode("dd", _hoisted_27, _toDisplayString(__props.formModel.email), 1)
        ]),
        _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t(_unref(dictionary).profile.doYouWantToChangeYourData)), 1),
        _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t(_unref(dictionary).profile.sendARequest)), 1),
        _createElementVNode("button", {
          class: "button my-pages-profile__submit-button",
          onClick: onChangeMyDataClick
        }, _toDisplayString(_ctx.$t(_unref(dictionary).profile.changeMyData)), 1)
      ])
    ]),
    _createVNode(_component_tress_modal, {
      "is-open": isModalOpen.value,
      class: "tress-modal-container--no-style",
      onOpen: onModalOpen,
      onClose: onModalClose
    }, {
      header: _withCtx(() => [
        _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t(_unref(dictionary).profile.requestForChangeProfile)), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_31, [
          (requestChangeProfileFormDefinition.value)
            ? (_openBlock(), _createBlock(_component_umbraco_form, {
                key: 0,
                definition: requestChangeProfileFormDefinition.value,
                "anti-forgery-token": __props.antiForgeryToken,
                "pre-values": __props.preValues
              }, {
                default: _withCtx(({ definition }) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(definition.pages, (page) => {
                    return (_openBlock(), _createBlock(_component_umbraco_form_page, {
                      page: page,
                      key: page.caption
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.fieldsets, (fieldset) => {
                          return (_openBlock(), _createBlock(_component_umbraco_form_fieldset, {
                            fieldset: fieldset,
                            key: fieldset.id
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldset.columns, (column) => {
                                return (_openBlock(), _createBlock(_component_umbraco_form_fieldset_column, {
                                  column: column,
                                  key: column.caption
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.fields, (field) => {
                                      return (_openBlock(), _createBlock(_component_umbraco_form_field, {
                                        field: field,
                                        key: field.caption
                                      }, null, 8, ["field"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["column"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["fieldset"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["page"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["definition", "anti-forgery-token", "pre-values"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["is-open"])
  ]))
}
}

})